<template>
  <mdb-container class="mt-2">

    <div v-if="success">
      <!--    Page main section-->

      <jumbotron :subtitle="$t('startPage.subtitle')" :title="$t('startPage.title')"></jumbotron>
  
      <!--    Buttons-->
      <mdb-row class="justify-content-center mt-3">
        <mdb-col v-for="event in events" :key="event.id" class="mb-3 selection-buttons" col="lg-3">
          <div :class="{'active' :  selectedEvent.id === event.id}" class="selection-button"
               @click.prevent="updateEventType(event)">
              <span class="selection-button--icon">
                <img :alt="event.title" :src="event.icon">
              </span>
            <span class="selection-button--text pl-2">
                {{ event.title }}
              </span>
          </div>
        </mdb-col>
      </mdb-row>
  
        <!--    Next button-->
        <mdb-row class="justify-content-center mt-3">
        <mdb-col>
          <mdb-btn v-if="selectedEvent.id" block class="large-button " :class="{'btn-primary': selectedEvent.id, 'btn-secondary': !selectedEvent.id}" @click="next">
            {{ $t('general.next') }}
          </mdb-btn>
        </mdb-col>
      </mdb-row>
        
    </div>
    
    <div class="configurator-error" v-else>
      
      <mdb-row class="justify-content-center mt-3">
      <mdb-col>
        <div class="alert alert-danger p-5" role="alert" data-mdb-color="danger">
          {{ message }}
        </div>
      </mdb-col>
    </mdb-row>
      
    </div>

  </mdb-container>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {
  name: 'LandingPage',

  data() {
    return {
      events: [],
      success: false,
      message: ""
    }
  },

  metaInfo() {
    return {
      title: this.$t('startPage.metaTitle')
    }
  },

  mounted() {
    this.updateIsLoading(true);

    this.$http.getEventTypes()
        .then(({data}) => {
          this.success = data.success;
          if (data.success) {
            this.updateAccountId(data.accountId ? data.accountId : null);
            this.events = data.data.options;
            Object.entries(this.events).map(([key, value]) => {
              value.freeTextFieldId = data.data.id;
              value.freeTextFieldType = data.data.title;

              // if the router event is set, set the selected event to the router event
              if (
                  (this.$route.query.event_type && this.$route.query.event_type === key) ||
                  (this.$route.params.event_type && this.$route.params.event_type == key)
              ) {
                this.updateEventType(value);
                this.next();
              }
            })
          }else{
              this.message = data.data;
          }
        })
        .finally(() => this.updateIsLoading(false))

  },

  computed: {

    ...mapGetters({
      selectedEvent: "getEventType"
    })

  },
  methods: {

    ...mapActions(['updateEventType', 'updateIsLoading', 'updateAccountId']),

    next() {
      this.$router.push({name: 'PersonDetails'})
    }

  }
}

</script>


<style lang="scss" scoped>
@import "_index.scss";
</style>


// WEBPACK FOOTER //
// src/components/pages/landing-page/index.vue